module.exports = __webpack_public_path__ + "img/xzbg.8428ff53.jpg";